import { createContext, useContext } from 'react'

export const CssZoomContext = createContext(1)

export function useCssZoom(): number {
  return useContext(CssZoomContext)
}
